import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteLogo } from '../components/SiteLogo';
import { LandingHero } from '../components/landing/LandingHero';
import { TourBooking } from '../components/landing/TourBooking';
import { PackageHighlights } from '../components/landing/PackageHighlights';
import { BravoFeature } from '../components/landing/BravoFeature';
import { PressLogos } from '../components/landing/PressLogos';
import { RealWeddings } from '../components/landing/RealWeddings';
import { TestimonialBand } from '../components/landing/TestimonialBand';
import { SiteFooter } from '../components/landing/SiteFooter';
import type { LandingVariant } from '../types/landing';
type LandingPageProps = {
  variant: LandingVariant;
};
export function LandingPage({
  variant
}: LandingPageProps) {
  useEffect(() => {
    document.title = variant.pageTitle;
    window.scrollTo(0, 0);
  }, [variant]);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-111" data-mp="lmxt14gh3th3">
      <header className="flex items-center justify-center border-b border-ink/10 px-6 py-4" data-id="element-112" data-mp="2zj70xaz4nz8d">
        <Link to={`/${variant.slug}`} aria-label="Twenty Mile House home" className="inline-block" data-id="element-113" data-mp="33kiiqubrfg60">
          <SiteLogo size="sm" data-id="element-114" data-mp="38jvds2csbtjo" />
        </Link>
      </header>
      <main data-id="element-115" data-mp="38iaigainc6kr">
        <LandingHero eyebrow={variant.eyebrow} headline={variant.headline} intro={variant.intro} data-id="element-116" data-mp="38hinn1wvicvj" />
        <TourBooking data-id="element-117" data-mp="3dcerr0fdwqp0" />
        <PackageHighlights stats={variant.stats} data-id="element-118" data-mp="3i9ooz290m6ne" />
        <BravoFeature data-id="element-119" data-mp="3i8ws7o3om2vj" />
        <PressLogos data-id="element-120" data-mp="3ibj2hvhyiwhg" />
        <RealWeddings data-id="element-121" data-mp="3n89eo7qn57xl" />
        <TestimonialBand data-id="element-122" data-mp="3n7q6vjupfzxa" />
      </main>
      <SiteFooter data-id="element-123" data-mp="3n6olomjz5x1u" />
    </div>;
}